/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const FilterIcon = ({ color = "currentColor", className = "" }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="-6XSbkHh"
      className={className}
    >
      <path
        d="M6.3999 4.66251H5.09919L5.51051 5.89647L7.11051 10.6965L7.16261 10.8528L7.26486 10.9819L9.59574 13.9262V18.8V19.7375H10.5332H12.6666H13.6041V18.8V13.9262L15.9349 10.9819L16.0372 10.8528L16.0893 10.6965L17.6893 5.89647L18.1006 4.66251H16.7999H6.3999Z"
        stroke={color}
        strokeWidth="1.875"
        test-id="F0gzIClB"
      />
    </svg>
  );
};

export default FilterIcon;
